export enum ThreadStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
